const IS_NEW_COMPANY_KEY = "isNewCompany";
const SELECTED_SLOT_KEY = "selected_slot";
const SELECTED_CERTIFICATE_KEY = "selected_certficate";
const COMPANY_KEY = "company";
const WIZARD_INFO_KEY = "wizardInfo";


// action types
export const UPDATE_SELECTED_SLOT = "updateSelectedSlot";
export const UPDATE_SELECTED_CERTFICATE = "updateSelectedCertificate";
export const UPDATE_COMPANY = 'updateCompany';
export const UPDATE_IS_NEW_COMPANY = 'isNewCompany';
export const UPDATE_WIZARD_INFO = "updateWizardInfo"

export const GET_SLOTS = "GetSlots"
export const GET_SELECTED_CERTIFICATE = "GetSelectedCertificate";
export const GET_TOKEN = "GetToken";
export const GET_ACCOUNT = "GetAccount";
export const GET_CREATION = "GetCreation";
export const GET_HEAD_COMPANY = "GetHeadCompany";


// mutation types
export const SET_SELECTED_SLOT = "setSelectedSlot";
export const SET_SELECTED_CERTIFICATE = "setSelectedCertificate";
export const SET_COMPANY = 'setCompany';
export const SET_IS_NEW_COMPANY = 'isNewCompany';

export const GET_SLOTS_INFO = 'GetSlotsInfo'
export const GET_SELECTED_CERTIFICATE_INFO = "GetSelectedCertificateInfo";
export const GET_TOKEN_INFO = "GetTokenInfo";
export const GET_ACCOUNT_INFO = "GetAccountInfo";
export const CREATION_INFO = "CreationInfo";
export const GET_HEAD_COMPANY_MODULES = "GetHeadCompanyModules";

export const SET_WIZARD_INFO = "updateWizardInfo";


const state = {
    selected_slot: {
        SlotName: ''
    },
    selected_certficate: {
        CommonName: '',
        SerialNumber: '',
        index: -1
    },
    get_Slots: [],
    get_Selected_Certificate: {},
    get_Token: {},
    get_Account: {},
    creationInfo: {},
    headCompanyModules: [],
    company: {},
    isNewCompany: false,
    wizardInfo: {
        CompanyID: '-1',
        IsDealer: false
    }
};

const getters = {
    currentSelectedSlot(state) {
        return state.selected_slot;
    },
    currentSelectedCertficate(state) {
        return state.selected_certficate;
    },
    currentCompany(state) {
        return state.company
    },
    currentIsNewCompany(state) {
        return state.isNewCompany;
    },
    currentWizardInfo(state) {
        return state.wizardInfo;
    },
    getSlots(state) {
        return state.get_Slots
    },
    getCertificate(state) {
        return state.get_Selected_Certificate
    },
    getToken(state) {
        return state.get_Token
    },
    getAccount(state) {
        return state.get_Account
    },
    creationInfo(state) {
        return state.creationInfo
    },
    headCompanyModules(state) {
        return state.headCompanyModules
    }
};

const actions = {
    [UPDATE_SELECTED_SLOT](context, payload) {
        context.commit(SET_SELECTED_SLOT, payload);
    },
    [UPDATE_SELECTED_CERTFICATE](context, payload) {
        context.commit(SET_SELECTED_CERTIFICATE, payload);
    },
    [UPDATE_COMPANY](context, payload) {
        context.commit(SET_COMPANY, payload);
    },
    [UPDATE_IS_NEW_COMPANY](context, payload) {
        context.commit(SET_IS_NEW_COMPANY, payload);
    },
    [UPDATE_WIZARD_INFO](context, payload) {
        context.commit(SET_WIZARD_INFO, payload);
    },
    async [GET_SLOTS](context, payload) {
        context.commit(GET_SLOTS_INFO, payload);
    },
    async [GET_SELECTED_CERTIFICATE](context, payload) {
        context.commit(GET_SELECTED_CERTIFICATE_INFO, payload);
    },
    async [GET_TOKEN](context, payload) {
        context.commit(GET_TOKEN_INFO, payload);
    },
    async [GET_ACCOUNT](context, payload) {
        context.commit(GET_ACCOUNT_INFO, payload);
    },
    async [GET_CREATION](context, payload) {
        context.commit(CREATION_INFO, payload);
    },
    async [GET_HEAD_COMPANY](context, payload) {
        context.commit(GET_HEAD_COMPANY_MODULES, payload);
    },
};

const mutations = {
    [SET_SELECTED_SLOT](state, selectedSlot) {
        localStorage.setItem(SELECTED_SLOT_KEY, JSON.stringify(selectedSlot))
        state.selected_slot = selectedSlot;
    },
    [SET_SELECTED_CERTIFICATE](state, selectedCertficate) {
        localStorage.setItem(SELECTED_CERTIFICATE_KEY, JSON.stringify(selectedCertficate))
        state.selected_certficate = selectedCertficate;
    },
    [SET_COMPANY](state, company) {
        // sessionStorage.setItem(COMPANY_KEY, JSON.stringify(company))
        localStorage.setItem(COMPANY_KEY, JSON.stringify(company))
        state.company = company;
    },
    [SET_IS_NEW_COMPANY](state, isNewCompany) {
        localStorage.setItem(IS_NEW_COMPANY_KEY, JSON.stringify(isNewCompany));
        state.isNewCompany = isNewCompany;
    },
    [SET_WIZARD_INFO](state, wizardInfo) {
        localStorage.setItem(WIZARD_INFO_KEY, JSON.stringify(wizardInfo));
        state.wizardInfo = wizardInfo;
    },
    [GET_SLOTS_INFO](state, slots) {
        state.get_Slots = slots
    },
    [GET_SELECTED_CERTIFICATE_INFO](state, certificate) {
        state.get_Selected_Certificate = certificate
    },
    [GET_TOKEN_INFO](state, token) {
        state.get_Token = token
    },
    [GET_ACCOUNT_INFO](state, account) {
        state.get_Account = account
    },
    [CREATION_INFO](state, creationInfo) {
        state.creationInfo = creationInfo
    },
    [GET_HEAD_COMPANY_MODULES](state, modules) {
        state.headCompanyModules = modules
    }

};

export default {
    state,
    actions,
    mutations,
    getters
};
